import { clearMockSession, isMockAuthEnabled } from './mockAuth';

export const handleSessionExpired = (showToast?: (message: string, type: 'success' | 'error' | 'warning' | 'info') => void): void => {
  // Clear mock session if mock auth is enabled
  if (isMockAuthEnabled()) {
    clearMockSession();
  }
  
  // Clear all caches
  localStorage.clear();
  sessionStorage.clear();
  
  // Show toast message if available
  if (showToast) {
    showToast('Session expired', 'warning');
  }
  
  // Redirect to homepage and force full reload
  window.location.href = '/';
};
